/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//shop subnav
let mainNavEl = null;
let mainNavHeight = 0;
let subNavEl = null;
let subNavHeight = 0;

document.addEventListener("DOMContentLoaded", (event) => {
  //offsetHeight could also be clientHeight
  mainNavEl = document.getElementById("section-header");
  mainNavHeight = mainNavEl.clientHeight;

  subNavEl = document.getElementById("shop-subheader");
  subNavHeight = subNavEl.clientHeight;

  calcHeaderHeight();
});

function calcHeaderHeight() {
  let style = window.getComputedStyle(subNavEl);
  let matrix = new WebKitCSSMatrix(style.transform);
  let translateY = matrix.m42;

  const headerHeight = mainNavHeight + subNavHeight + translateY;
  document.documentElement.style.setProperty('--dynamic-header-height', headerHeight + 'px');
}

const shopDiv = document.getElementById("shop-subheader");

function hideShop() {
  shopDiv.classList.remove("visible");
  shopDiv.classList.add("hidden");
}

function toggleShop() {
  shopDiv.classList.toggle("visible");
  shopDiv.classList.toggle("hidden");
  calcHeaderHeight();

  const refresh = 1000 / 60; //60 fps
  const timeOut = 3000; //take CSS transition duration + some cushion
  let startResizeTimer = setInterval(calcHeaderHeight, refresh);
  let stopResizeTimer = setTimeout(function() {
    clearInterval(startResizeTimer);
  },timeOut);
}

//make links open in new tab- used especially for "Book next lesson" navigation link
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    //links[i].relList.add('noreferrer', 'noopener');
  }
}